<template>
  <div>
    <load-profile />
    <b-tabs
      v-model="activeTab"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
      @input="handleTabChange"
    >
      <!-- <b-tab
        v-if="$can('manage', 'manage-employee')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.employee')
          }}</span>
        </template>
        <employee-list />
      </b-tab> -->

      <b-tab
        v-if="$can('manage', 'manage-time-shift')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.timeShift')
          }}</span>
        </template>
        <time-shift-list />
      </b-tab>

      <b-tab
        v-if="$can('manage', 'manage-working-schedule')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="CalendarIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.workingSchedule')
          }}</span>
        </template>
        <working-schedule-list-v2 />
      </b-tab>
      <!-- <b-tab
        v-if="$can('manage', 'manage-working-schedule')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="CalendarIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.workingSchedule') + ' v2'
          }}</span>
        </template>
        <working-schedule-list-v2 />
      </b-tab> -->
      <b-tab
        v-if="$can('manage', 'manage-take-leave')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="BriefcaseIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.takeLeave')
          }}</span>
        </template>
        <take-leave-list />
      </b-tab>
      <b-tab
        v-if="$can('manage', 'manage-day-off')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="ListIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.dayOff')
          }}</span>
        </template>
        <day-off-list />
      </b-tab>
      <b-tab
        v-if="$can('manage', 'manage-break-time')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.breakTime')
          }}</span>
        </template>
        <break-time-list />
      </b-tab>
      <b-tab
        v-if="$can('manage', 'manage-holiday')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="SunIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.holiday')
          }}</span>
        </template>
        <div id="holiday" />
        <holiday-list />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BTab, BTabs, BCardText, BButton,
} from 'bootstrap-vue'
import HolidayList from '@/views/holiday/List.vue'
import EmployeeList from '@/views/employee/List.vue'
import TimeShiftList from '@/views/timeShift/List.vue'
import DayOffList from '@/views/dayOff/List.vue'
import TakeLeaveList from '@/views/takeLeave/List.vue'
// import WorkingScheduleList from '@/views/workingSchedule/List.vue'
import WorkingScheduleListV2 from '@/views/workingSchedule/ListV2.vue'
import BreakTimeList from '@/views/workingSchedule/breakTime/List.vue'
import Repository from '@/repositories/RepositoryFactory'

const DepartmentRepository = Repository.get('department')
const ProjectRepository = Repository.get('project')

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BTab,
    BTabs,
    HolidayList,
    EmployeeList,
    TimeShiftList,
    DayOffList,
    TakeLeaveList,
    // WorkingScheduleList,
    WorkingScheduleListV2,
    BreakTimeList,
  },

  data() {
    return {
      activeTab: 0,
      permissionType: 'summary-conversation',
      tabMapping: {
        timeShift: 0,
        workingSchedule: 1,
        takeLeave: 2,
        dayOff: 3,
        holiday: 4,
      },
    }
  },

  watch: {
    // Watch for query changes to update tab and breadcrumb
    '$route.query.tab': {
      immediate: true,
      handler(newTab) {
        if (newTab && this.tabMapping[newTab] !== undefined) {
          this.activeTab = this.tabMapping[newTab]
          this.updateBreadcrumb(newTab)
          this.$route.query.date = undefined
        }
      },
    },
  },

  created() {
    // Set initial active tab based on query parameter
    const { tab } = this.$route.query
    if (tab && this.tabMapping[tab] !== undefined) {
      this.activeTab = this.tabMapping[tab]
    }
  },

  methods: {
    handleTabChange(newTab) {
      // Get tab name from reverse mapping
      const tabNames = Object.keys(this.tabMapping)
      const newTabName = tabNames.find(key => this.tabMapping[key] === newTab)

      // Update route with new tab in query
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          tab: newTabName,
        },
      })

      // Update breadcrumb
      this.updateBreadcrumb(newTabName)
    },

    updateBreadcrumb(tabName) {
      const breadcrumbText = tabName === 'workingSchedule'
        ? 'breadcrumb.workingSchedule'
        : tabName === 'holiday'
          ? 'breadcrumb.holiday'
          : tabName === 'timeShift'
            ? 'breadcrumb.timeShift'
            : tabName === 'dayOff'
              ? 'breadcrumb.dayOff'
              : tabName === 'takeLeave'
                ? 'breadcrumb.takeLeave'
                : 'breadcrumb.employee'

      // Update the last item in the breadcrumb
      if (this.$route.meta.breadcrumb && this.$route.meta.breadcrumb.length > 0) {
        this.$route.meta.breadcrumb[this.$route.meta.breadcrumb.length - 1] = {
          text: breadcrumbText,
          active: true,
        }
      }
    },
  },

}
</script>
